import { render, staticRenderFns } from "./dhl.vue?vue&type=template&id=f3d3a3a6&"
import script from "./dhl.vue?vue&type=script&lang=js&"
export * from "./dhl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports